import { jsx as _jsx } from "react/jsx-runtime";
import { ORDER_STATE_LABEL } from './orderState';
import s from './OrderStateText.module.css';
export function OrderStateText({ state }) {
    return (_jsx("span", { className: s.status, "data-state": state, children: ORDER_STATE_LABEL[state] ?? state }));
}
